import React, { useState } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { MutateCloseServiceConnection } from "../../../utils/graphql/hooks/adminHooks";
import { toast } from "react-hot-toast";
import { Tooltip } from "react-tooltip";

interface ConfirmingService {
  name: string;
  deployment: string;
}

export default function ConnectedServices() {
  const closeServiceConnection = MutateCloseServiceConnection();
  const [confirmingService, setConfirmingService] =
    useState<ConfirmingService | null>(null);

  const connectedServices = useSelector(
    (state: RootState) => state.admin?.connectedServices,
    isEqual,
  );

  const handleDisconnect = () => {
    if (!confirmingService) return;
    closeServiceConnection({
      variables: {
        serviceName: confirmingService.name,
        deployment: confirmingService.deployment,
      },
    }).then((res) => {
      if (res.data?.closeServiceConnection) {
        toast.success(
          `${confirmingService.deployment} deployment of ${confirmingService.name} disconnected successfully`,
        );
      }
    });
    setConfirmingService(null);
  };

  return (
    <div className={styles.container}>
      <Tooltip id="deploymentsTooltip" style={{ zIndex: 9999 }} />
      <div className={styles.header}>Connected Services</div>
      <div className={styles.listWrapper}>
        {confirmingService && (
          <div className={styles.confirmationOverlay}>
            <div className={styles.confirmationQuestion}>
              Are you sure you want to disconnect {confirmingService.deployment}{" "}
              deployment of {confirmingService.name}?
            </div>
            <div className={styles.confirmationButtons}>
              <button
                className={styles.confirmButton}
                onClick={handleDisconnect}
              >
                Yes
              </button>
              <button
                className={styles.confirmButton}
                onClick={() => setConfirmingService(null)}
              >
                No
              </button>
            </div>
          </div>
        )}
        <div className={styles.connectedServicesList}>
          {connectedServices && connectedServices.length > 0 ? (
            connectedServices.map((service) => (
              <div key={service.name} className={styles.conectedServicesItem}>
                <div className={styles.serviceName}>{service.name}</div>
                {service.connections > 0 ? (
                  <div
                    className={styles.connectedStatus}
                    data-tooltip-id="deploymentsTooltip"
                    data-tooltip-content={service.deployments?.join(", ")}
                  >
                    CONNECTED
                    {service.name === "WinTAX Logger" || service.connections > 1
                      ? ` (${service.connections})`
                      : ""}
                    {service.connections === 1 && (
                      <button
                        className={styles.disconnectButton}
                        onClick={() =>
                          setConfirmingService({
                            name: service.name,
                            deployment: service.deployments[0],
                          })
                        }
                      >
                        ✖
                      </button>
                    )}
                  </div>
                ) : (
                  <div className={styles.disconnectedStatus}>NOT CONNECTED</div>
                )}
              </div>
            ))
          ) : (
            <div>No connected services</div>
          )}
        </div>
      </div>
    </div>
  );
}
